<template>
  <div v-show="initialized" class="size">
    <!-- TrustBox widget - Mini -->
    <div ref="widget" class="trustpilot-widget" data-locale="en-GB" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="57a83f0e0000ff00059338a7" data-style-height="130px" data-style-width="100%" data-theme="light">
      <a href="https://uk.trustpilot.com/review/vevox.com" target="_blank" rel="noopener">Trustpilot</a>
    </div>
    <!-- End TrustBox widget -->
  </div>
</template>

<script>
import trustpilot from '@/trustpilot';

export default {
  name: "TrustpilotWidget",
  data() {
    return {
      initialized: false
    }
  },
  mounted() {
    trustpilot.onInit(() => {
      this.initialized = true;
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(this.$refs.widget);
      }
    });
  }
}
</script>
<style scoped lang="scss">
.size {
  -webkit-transform: scale(0.8); //Safari scale doesn't work with percentages
  transform: scale(80%);
  max-height: 104px;
}

@media only screen and (max-height: 800px)  {
  .size {
    -webkit-transform: scale(0.6);
    transform: scale(60%);
    max-height: 78px;
    margin-top: -8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/signup/TrustpilotWidget.vue